import { render, staticRenderFns } from "./mining.vue?vue&type=template&id=0ffc62ed"
import script from "./mining.vue?vue&type=script&lang=js"
export * from "./mining.vue?vue&type=script&lang=js"
import style0 from "./mining.vue?vue&type=style&index=0&id=0ffc62ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports